import { fExecuteAPI } from "../../Server/Apis.jsx";
import {
  OS_DETAIL_GETROW,
  inv07_AttributesINV07_GETROW,
} from "../../Server/ApiV2.jsx";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys.jsx";
import { Set_HeadObject_A_PayMode } from "./SliceDelieveryNote.jsx";

import {
  KernCAConfig,
  DelieveryNoteRo,
  vRdxUserInfo,
} from "../../Redux/roStore.js";
import moment from "moment";
//customer
export const xGC_Toggle_Head_Customer_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "AcCd", headerName: "Code", width: 90 },
  { field: "Name2", headerName: "Name2", width: 450 },
  { field: "Name1", headerName: "Name1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const GCToggleSearch_Customer_Data = ["Any", "Code", "Name"];
export const sTrnTyp = "INV07";
export const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = DelieveryNoteRo();

  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

export const GCToggleSearch_Item_Data = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];
export const GridDataColumnsItemSearch = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 250 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];

export const GridDataSalesHistoryColumns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "A_VocNo", headerName: "Inv.No", width: 130 },
  { field: "A_PostDt", headerName: "Date", width: 130 },
  { field: "Unit", headerName: "Unit", width: 130 },
  { field: "GrossAmt", headerName: "GrossAmt", width: 130 },
  { field: "NetAmt", headerName: "NetAmt", width: 130 },
  { field: "Qty", headerName: "Qty", width: 130 },
];
export const GridDataSalesHistoryColumns2 = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "Location", headerName: "Location", width: 130 },
  { field: "StkQty", headerName: "StkQty", width: 130 },
  { field: "PRQty", headerName: "PRQty", width: 130 },
  { field: "SOQty", headerName: "SOQty", width: 130 },
  { field: "DOQty", headerName: "DOQty", width: 130 },
  { field: "SIQty", headerName: "SIQty", width: 130 },
  { field: "TRFQty", headerName: "TRFQty", width: 130 },
  { field: "ADJQty", headerName: "ADJQty", width: 130 },
  { field: "Reserved", headerName: "Reserved", width: 130 },
  { field: "AvlQty", headerName: "AvlQty", width: 130 },
  { field: "AvlQty", headerName: "AvlQty", width: 130 },
];

export const GCAudit_GridData_Columns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },

  {
    field: "User",
    headerName: "User Name",
    width: 130,
    headerClassName: "grid-header-row",
  },
  {
    field: "Date",
    headerName: "Date",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "Time",
    headerName: "Time",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "IP Address",
    headerName: "IP Address",
    width: 130,
    headerClassName: "grid-header-row",
  },
  {
    field: "Field",
    headerName: "Field",
    width: 130,
    headerClassName: "grid-header-row",
  },
  {
    field: "Old Value",
    headerName: "Old Value",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "New Value",
    headerName: "New Value",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 250,
    headerClassName: "grid-header-row",
  },
];

export const GridData_Columns_Detail_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  {
    field: "detail",
    headerName: "Detail",
    hide: false,
    width: 100,
  },
  {
    field: "B_Srno",
    headerName: "Sr.No",
    width: 50,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_Itmcd",
    headerName: "Item Code",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 300,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_Qty",
    headerName: "Qty",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "UnitName",
    headerName: "Unit",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_URateFc",
    headerName: "Unit Rate",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_GrossAmt",
    headerName: "Gross.Amt",
    width: 90,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_LDiscPerc",
    headerName: "L Disc %",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_LDiscAmt",
    headerName: "L Disc.Amt",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_FocAmt",
    headerName: "Foc.Amt",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_NetAmt",
    headerName: "Net.Amt",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_ExciseTaxNetAmt",
    headerName: "B_ExciseTaxNetAmt",
    width: 100,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_TaxAmt",
    headerName: "B_TaxAmt1",
    width: 100,
    headerClassName: "grid-header-row",
  },

  {
    field: "B_ExciseTaxAmt",
    headerName: "B_ExciseTaxAmt",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "SplDiscAmt1",
    headerName: "SplDiscAmt1",
    width: 150,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_TaxDept",
    headerName: "B_TaxDept",
    width: 150,
    headerClassName: "grid-header-row",
  },

  {
    field: "B_Unit",
    headerName: "B_Unit",
    width: 100,
    hide: true,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_BaseQty",
    headerName: "B_BaseQty",
    width: 90,
    hide: true,
    headerClassName: "grid-header-row",
  },
  {
    field: "B_URateLc",
    headerName: "B_URateLc",
    width: 90,
    hide: true,
    headerClassName: "grid-header-row",
  },

  { field: "B_TDiscPerc", headerName: "B_TDiscPerc", width: 90, hide: true },
  { field: "B_TDiscAmt", headerName: "B_TDiscAmt", width: 90, hide: true },
  { field: "B_FocFlag", headerName: "B_FocFlag", width: 90, hide: true },
  { field: "B_TaxPerc", headerName: "B_TaxPerc", width: 90, hide: true },
  { field: "B_Rounding", headerName: "B_Rounding", width: 90, hide: true },
  { field: "B_LandVal", headerName: "B_LandVal", width: 90, hide: true },
  { field: "B_RefDocTyp", headerName: "B_RefDocTyp", width: 90, hide: true },
  { field: "RefVocName", headerName: "RefVocName", width: 90, hide: true },
  { field: "B_RefDocNo", headerName: "B_RefDocNo", width: 90, hide: true },
  { field: "B_BatchNo", headerName: "B_BatchNo", width: 90, hide: true },
  { field: "BatchCrl", headerName: "BatchCrl", width: 90, hide: true },
  { field: "DOFlag", headerName: "DOFlag", width: 90, hide: true },

  { field: "B_TaxDept2", headerName: "B_TaxDept2", width: 90, hide: true },
  { field: "B_TaxPerc2", headerName: "B_TaxPerc2", width: 90, hide: true },
  { field: "B_TaxAmt2", headerName: "B_TaxAmt2", width: 90, hide: true },
  { field: "B_IncGroup", headerName: "B_IncGroup", width: 100, hide: true },
  { field: "IncGroupName", headerName: "IncGroupName", width: 100, hide: true },
  { field: "B_SuprvPerc", headerName: "B_SuprvPerc", width: 90, hide: true },
  { field: "B_OthersPerc", headerName: "B_OthersPerc", width: 90, hide: true },
  { field: "B_SLANSuprv", headerName: "B_SLANSuprv", width: 90, hide: true },
  {
    field: "B_SlabAmtSuprv",
    headerName: "B_SlabAmtSuprv",
    width: 90,
    hide: true,
  },
  { field: "B_SLANOther", headerName: "B_SLANOther", width: 90, hide: true },
  {
    field: "B_SlabAmtOther",
    headerName: "B_SlabAmtOther",
    width: 90,
    hide: true,
  },
  { field: "Field8", headerName: "Field8", width: 90, hide: true },
];
export const GCSearch_GridData_Columns_Def = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
    width: 70,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "VocName",
    headerName: "Doc.Name",
    hide: false,
    width: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "A_VocNo",
    headerName: "Doc.No",
    hide: false,
    width: 150,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "A_PostDt",
    headerName: "Date",
    hide: false,
    width: 100,
    align: "right",
    headerAlign: "right",
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_RefNo",
    headerName: "Ref.No",
    hide: false,
    width: 90,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "PartyName",
    headerName: "PartyName",
    hide: false,
    width: 200,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "LocName",
    headerName: "Location",
    hide: false,
    width: 130,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "A_NetAmt",
    headerName: "Net.Amt",
    hide: false,
    width: 90,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "SalesGroup",
    headerName: "SalesGroup",
    hide: false,
    width: 200,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "A_DocStat",
    headerName: "Status",
    hide: true,
    width: 90,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "A_VocTyp",
    headerName: "Doc.Typ",
    hide: true,
    width: 90,
    align: "right",
    headerAlign: "right",
  },
];

export const GCVanMaster_SalesGroup_GridData_Columns = [
  { field: "id", headerName: "id", hide: true },
  { field: "UId", headerName: "Code" },
  { field: "Srno", headerName: "SrNo", width: 90 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "EMPNAME", headerName: "Employee Name", width: 350 },
  { field: "Typ", headerName: "Type", width: 100 },
  { field: "Active", headerName: "Active", width: 100 },
];
export const GCEmployee_SalesGroup_GridData_Columns = [
  { field: "id", headerName: "id", hide: true },
  { field: "SrNo", headerName: "SrNo", width: 50 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "SName", headerName: "Name", width: 300 },
  { field: "FName", headerName: "First Name", width: 150, hide: true },
  { field: "LName", headerName: "Last Name", width: 180, hide: true },
  { field: "MName", headerName: "Middle Name", width: 100, hide: true },
  { field: "InActive", headerName: "InActive", width: 60 },
  { field: "JOBTITLE", headerName: "Job Title", width: 80 },
  { field: "Gender", headerName: "Gender", width: 60 },
  { field: "DOB", headerName: "DOB", width: 100 },
  { field: "Country", headerName: "Country", width: 120 },
  { field: "Maritial", headerName: "Maritial", width: 60 },
  { field: "Mobile", headerName: "Mobile", width: 120 },
  { field: "Dept", headerName: "Dept", width: 50 },
  { field: "Br", headerName: "Br", width: 50 },
  { field: "Loc", headerName: "Loc", width: 50 },
  { field: "EmployementDt", headerName: "EmployementDt", width: 180 },
  { field: "DOJ", headerName: "DOJ", width: 190 },
  { field: "Phone", headerName: "Phone", width: 90 },
  { field: "EMail", headerName: "EMail", width: 150 },
  { field: "CompEMail", headerName: "CompEMail", width: 90 },
  { field: "CompPhone", headerName: "CompPhone", width: 90 },
  { field: "CompExt", headerName: "CompExt", width: 90 },
  { field: "CompMobile", headerName: "CompMobile", width: 120 },
  { field: "TerminationDt", headerName: "TerminationDt", width: 90 },
];

//Narration Search
export const columnsNarrationDropdownSearch = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "Code", headerName: "Code", width: 80, hide: true },
  { field: "Name", headerName: "Name1", width: 220 },
];
var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow = vheaderArrow !== 1 ? vheaderArrow + 1 : 1;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow = vheaderArrow !== 0 ? vheaderArrow - 1 : 0;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const Get_GCToggleSearch_Item_Dropdown_Grid = async (
  xData,
  xType,
  xA_Loc,
  set_GCToggleSearch_Item_Row_GridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    set_GCToggleSearch_Item_Row_GridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.response?.data?.message ||
        vItemSearch?.message ||
        vItemSearch.response.data.Status ||
        "Error in DocLoading"
    );
  }
};

export const Get_GCToggleSearch_Customer_Api = async (
  xData,
  xType,
  xA_Loc,
  setCustSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("PARTYSEARCH001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setCustSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.response?.data?.message ||
        vItemSearch?.message ||
        vItemSearch.response.data.Status ||
        "Error in DocLoading"
    );
  }
};

const fDefaultPayload = (xPaymode, dispatch, setPaymodeEnable) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode;
  //client req
  if (xPaymode == "BOTH") {
    setPaymodeEnable(false);
  } else {
    setPaymodeEnable(true);
  }

  dispatch(
    Set_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return iPaymode;
};
export const xGCSearchBtn_Columns_DropdownSearch = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "AcCd", headerName: "Code", width: 100 },
  { field: "Name2", headerName: "Name2", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
const GetOSAmount = async (xLoc, xParty, setOsAmount) => {
  const { HeadObject } = DelieveryNoteRo();
  let vOsAmtObj = {
    loc: xLoc,
    unit: xParty,
  };
  if (HeadObject.A_DocStat === "ENTER") {
    const vOsAmt = await fExecuteAPI("Common_partyosamtt_GETROW", vOsAmtObj);
    if (
      vOsAmt?.Type?.toUpperCase() === "SUCCESS" &&
      vOsAmt?.ResultSet?.length > 0
    ) {
      setOsAmount((obj) => ({
        ...obj,
        NetOsAmt: vOsAmt.ResultSet[0].NetAmtWithoutPDC,
        PDCAmt: vOsAmt.ResultSet[0].PDCAmt,
        BalanceOsAmt: vOsAmt.ResultSet[0].NetAmtAfterPDC,
      }));
    } else {
      fAlertToast(
        "FAILED",
        vOsAmt.response.data.message ||
          vOsAmt.response.data.Status ||
          vOsAmt?.message ||
          "Error in Common_partyosamtt_GETROW"
      );
    }
  } else {
    setOsAmount((obj) => ({
      ...obj,
      NetOsAmt: 0,
      PDCAmt: 0,
      BalanceOsAmt: 0,
    }));
  }
};

export const GetAttributes = async (
  setUser_Doc_Arr,
  setObjectRights,
  setDocLoading,
  setCurrency,
  setLocation,
  setTaxType,
  setType,
  setSalesman
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCd: vRdxUserInfoObj.UserID,
    userGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await inv07_AttributesINV07_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.Voucher);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setLocation(iAttributes?.data?.ResultSet?.Location);
    setTaxType(iAttributes?.data?.ResultSet?.TaxType);
    setType(iAttributes?.data?.ResultSet?.Type);
    setSalesman(iAttributes?.data?.ResultSet?.Salesman);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export const getOSDetail = async (set, party) => {
  let obj = {
    v_AcCd: party,
    v_Typ: "D",
    v_Br: "",
  };
  let ApiObj = await OS_DETAIL_GETROW(obj);
  console.log("ApiObj", ApiObj);

  if (ApiObj?.data?.ResultSet?.length > 0) {
    let { OS, PDCAmt, CrLimit, FixedCost, CrLmtPrd } =
      ApiObj?.data?.ResultSet[0];

    let PartyNetOs = OS + PDCAmt;

    set({
      partyos: OS,
      partypdc: PDCAmt,
      CrLimit: CrLimit,
      partyNetOS: PartyNetOs,
      CrlimitPRD: CrLmtPrd,
      FixedCost: FixedCost,
    });
  } else {
    set({
      partyos: "0",
      partypdc: "0",
      CrLimit: "0",
      partyNetOS: "0",
      CrlimitPRD: "0",
      FixedCost: "0",
    });
  }
};
const GetUnitArr = async (xItemCode, setUnit, loaderScreen = true) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };

  const UnitInfo = await fExecuteAPI(
    "GETITEMUNITS_GETROW",
    itemUnitobj,
    loaderScreen
  );
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo?.Type?.response?.data?.message ||
        UnitInfo?.message ||
        UnitInfo?.response?.data?.Status ||
        "Error in UnitArr"
    );
    return [];
  }
};
export const BatchFlag = () => {
  const { DBKernObj } = KernCAConfig();
  return DBKernObj.BATCH_NO_AUTO.Val === "Y";
};

export const WARRANTY_Flag = () => {
   const { DBKernObj } = KernCAConfig();
  return DBKernObj.WARRANTY_ACTIVE.Val === "Y";
};

export {
  GetUnitArr,
  fRightClick,
  fLeftClick,
  fDefaultPayload,
  Get_GCSearchBtn,
  GetOSAmount,
};
